/* HandlerKraft lead-form rules — one definition for every form (ARCH-023): the PDP quote box,
   /cart, the footer, contact, rental and service forms all call window.HKValidate, so the same
   name, phone or e-mail passes or fails everywhere. Only the rules live here; each form keeps
   its own messages, honeypot, fill-time check, drafts and retry logic.
   Loaded with defer in <head> before content_for_header, so it runs before every section script. */
(function () {
  'use strict';
  // replaces the lenient inline stub from layout/theme.liquid (window.HKValidate.fallback)
  if (window.HKValidate && !window.HKValidate.fallback) return;

  /* Moldovan numbers: 0XX XXX XXX, +373 XX XXX XXX, 00373…, 373…, 8 bare digits and the common
     "+373 0XX…" typo; the national number starts with 2/3/5 (landline) or 6/7 (mobile).
     Other countries: written with + or 00 (E.164, 8–15 digits).
     Returns { ok, empty?, md?, e164?, display? }. */
  function phone(raw) {
    var s = String(raw || '').trim();
    if (!s) return { ok: false, empty: true };
    var intl = /^(\+|00)/.test(s);
    var d = s.replace(/\D/g, '');
    if (/^00/.test(s)) d = d.slice(2);
    if (d.indexOf('3730') === 0 && d.length === 12) d = '373' + d.slice(4);
    var nsn = null;
    if (d.indexOf('373') === 0 && (intl || d.length === 11)) {
      if (d.length !== 11) return { ok: false };
      nsn = d.slice(3);
    } else if (!intl && d.length === 9 && d.charAt(0) === '0') {
      nsn = d.slice(1);
    } else if (!intl && d.length === 8) {
      nsn = d;
    }
    if (nsn !== null) {
      if (!/^[23567]\d{7}$/.test(nsn)) return { ok: false };
      return {
        ok: true, md: true, e164: '+373' + nsn,
        display: '+373 ' + nsn.slice(0, 2) + ' ' + nsn.slice(2, 5) + ' ' + nsn.slice(5)
      };
    }
    if (intl && d.length >= 8 && d.length <= 15 && d.charAt(0) !== '0') {
      return { ok: true, md: false, e164: '+' + d, display: '+' + d };
    }
    return { ok: false };
  }

  /* Names in any script (Romanian ș/ț, Gagauz ü/ç/ğ, Cyrillic …): 2–80 characters, at least two
     letters; letters, combining marks, spaces, apostrophes, dots and hyphens only. */
  var LETTER_G, NAME_BAD;
  try {
    LETTER_G = new RegExp('\\p{L}', 'gu');
    NAME_BAD = new RegExp("[^\\p{L}\\p{M}\\s'\u2019.\\-]", 'u');
  } catch (e) {
    LETTER_G = /[A-Za-z\u00C0-\u024F\u0370-\u03FF\u0400-\u04FF]/g;
    NAME_BAD = /[0-9_@#$%^&*()+=\[\]{};:"\\|<>\/?!~`,]/;
  }
  function name(v) {
    v = String(v || '').trim();
    if (v.length < 2 || v.length > 80 || NAME_BAD.test(v)) return false;
    return (v.match(LETTER_G) || []).length >= 2;
  }

  function email(v) {
    return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/.test(String(v || '').trim());
  }

  window.HKValidate = { phone: phone, name: name, email: email };
})();
